export default "__VITE_ASSET__CgBfL$Xc__"